import * as React from 'react';
import { IIconProps } from './IIconProps';

const Control: React.FunctionComponent<IIconProps> = ({ size = 'sm', color = "currentColor" }) => {
    return <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3.5H10.4C10.8243 3.5 11.2313 3.6873 11.5314 4.0207C11.8314 4.3541 12 4.80628 12 5.27778V11.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 6.5V13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 6.5C5.10457 6.5 6 5.60457 6 4.5C6 3.39543 5.10457 2.5 4 2.5C2.89543 2.5 2 3.39543 2 4.5C2 5.60457 2.89543 6.5 4 6.5Z" fill={color} />
        <path d="M12 14.5C13.1046 14.5 14 13.6046 14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5Z" fill={color} />
    </svg>


};

export default Control;
